module.exports = __webpack_public_path__ + "78d8883d60048334f933513f57048327.svg";